import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type {
	ApplicantDetailsNameReturnType,
	ApplicantDetailsPersonsProps,
} from '@gov-nx/ui/types';

export const useApplicantDetailsName = ({
	individualPerson,
	businessPerson,
}: ApplicantDetailsPersonsProps): ApplicantDetailsNameReturnType => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Component);

	if (individualPerson?.jmeno && individualPerson?.prijmeni) {
		return {
			label: t('zadatel.pole.udaje.jmeno-prijmeni'),
			name: `${individualPerson.jmeno} ${individualPerson.prijmeni}`,
		};
	}

	if (businessPerson?.nazevSpolecnosti) {
		return {
			label: t('zadatel.pole.udaje.nazev-spolecnosti'),
			name: businessPerson.nazevSpolecnosti,
		};
	}

	return null;
};
